import Axios from "axios";
import { urlAPI } from "Common";
import React, { useState, useEffect } from "react";
import { Card, Row, Col, Button, Form, Modal, Accordion, Tabs, Tab, Nav, Offcanvas } from "react-bootstrap";
import Select from "react-select";
import moment from "moment";
import Center from "react-center";
import * as Icons from "react-feather";

export default function Step1Page(props) {
  const {
    dataStep1,
    setDataStep1,
    fetchSelectorUnit,
    selectorUnit,
    loadingUnit,
    handleNext,
    setUnitJenis3,
    selectorRS,
    loadingPengumuman,
  } = props;

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [showUnitDateModal, setShowUnitDateModal] = useState(false);
  const [showRegistrationModal, setShowRegistrationModal] = useState(false);
  const [visitDate, setVisitDate] = useState("");
  const [selectedSBU, setSelectedSBU] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedMenu, setSelectedMenu] = useState(null);
  const [modalHistory, setModalHistory] = useState([]);

  const JAM_BUKA = 8; // 08:00 WIB (jam server)
  const [belumBuka, setBelumBuka] = useState(false);

  useEffect(() => {
    if (!isSpecialTodayH1Unit) {
      setBelumBuka(false);
      return;
    }
    // Fail-closed: untuk unit khusus, anggap belum buka sampai jam server terverifikasi.
    setBelumBuka(true);
    let batal = false;
    const cek = () =>
      Axios.get(urlAPI + "/public/regonline/cektanggal")
        .then((response) => {
          const row = response?.data?.result?.[0];
          if (!batal) setBelumBuka(!(Number(row?.Jam) >= JAM_BUKA));
        })
        .catch(() => {});
    cek();
    const timer = setInterval(cek, 60000);
    return () => {
      batal = true;
      clearInterval(timer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataStep1?.unit]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (showModal && selectedMenu?.label === "Daftar Online") {
      setShowUnitDateModal(true);
      setShowModal(false);
      setModalHistory(["unitDate"]);
    }
  }, [showModal, selectedMenu]);

  useEffect(() => {
    if (showRegistrationModal) {
      setShowUnitDateModal(false);
      setModalHistory(["registration"]);
    }
  }, [showRegistrationModal]);

  const selectorSBU = [
    { value: "RSPG", label: "Rumah Sakit Petrokimia Gresik", location: "https://goo.gl/maps/Kaugv4ev8JbqkSDr7", img: "assets/img/rspg.png", profile: "Rumah Sakit Petrokimia Gresik adalah rumah sakit yang menyediakan layanan kesehatan lengkap dan berkualitas." },
    { value: "GRAHU", label: "Rumah Sakit Grha Husada", location: "https://goo.gl/maps/YtnjVQkmEX7m9tXD9", img: "assets/img/rsgh.png", profile: "Rumah Sakit Grha Husada menawarkan berbagai layanan medis dengan fasilitas modern." },
    { value: "DRIYO", label: "RSPG Driyorejo", location: "https://goo.gl/maps/RCTEzS4JEMgRGNwt8", img: "assets/img/rspgd.png", profile: "RSPG Driyorejo adalah rumah sakit dengan berbagai layanan kesehatan untuk masyarakat." },
    // { value: "PPK1", label: "Klinik PPK I PT Petrokimia Gresik", location: "https://goo.gl/maps/4xYCCL2nRrFaBq9k9", img: "assets/img/logoppk.png", profile: "Klinik PPK I PT Petrokimia Gresik memberikan layanan kesehatan bagi karyawan dan masyarakat sekitar." },
    // { value: "KALIMANTAN", label: "Klinik Satelit Kalimantan", location: "https://goo.gl/maps/9pMZG3iPkkdbD5o88", img: "assets/img/logosatkal.png", profile: "Klinik Satelit Kalimantan menyediakan layanan kesehatan dasar dan spesialis." },
    // { value: "WA", label: "Klinik PPK I Wringinanom Gresik", location: "https://goo.gl/maps/cDmnMQjzbGARio539", img: "assets/img/logoppk.png", profile: "Klinik PPK I Wringinanom Gresik menyediakan layanan kesehatan dasar dan spesialis." },
  ];

  const SPECIAL_H1_UNITS = [];
  const SPECIAL_TODAY_H1_UNITS = ["A62", "P48", "G16", "G17", "G18"];
  const isSpecialH1Unit = SPECIAL_H1_UNITS.includes(dataStep1?.unit);
  const isSpecialTodayH1Unit = SPECIAL_TODAY_H1_UNITS.includes(dataStep1?.unit);
  const serverNow = moment();
  const registrationStartTime = moment().hour(8).minute(0).second(0).millisecond(0);
  const isSpecialH1Available = !isSpecialH1Unit || serverNow.isSameOrAfter(registrationStartTime);
  const isSpecialBlocked = isSpecialH1Unit && !isSpecialH1Available;

  const hariIni = isSpecialTodayH1Unit
    ? moment().format("YYYY-MM-DD")
    : isSpecialH1Unit
    ? moment().add(1, "days").format("YYYY-MM-DD")
    : moment().format("YYYY-MM-DD");
  const maxHari = (isSpecialH1Unit || isSpecialTodayH1Unit)
    ? moment().add(1, "days").format("YYYY-MM-DD")
    : dataStep1?.sbu === "RSPG" && dataStep1?.unit !== "P37"
    ? moment().add(30, "days").format("YYYY-MM-DD")
    : dataStep1?.sbu === "RSPG" && dataStep1?.unit === "P37"
    ? moment().add(5, "days").format("YYYY-MM-DD")
    : moment().add(3, "days").format("YYYY-MM-DD");

  // === SATU-SATUNYA sumber kebenaran validasi tanggal ===
  const isDateInRange = (d) =>
    typeof d === "string" &&
    moment(d, "YYYY-MM-DD", true).isValid() &&
    d >= hariIni &&
    d <= maxHari;

  const dateValid = isDateInRange(dataStep1?.date);
  const dateOutOfRange = !!dataStep1?.date && !dateValid;
  const dateErrorMessage = `Pendaftaran bisa dilakukan ${moment(hariIni).format("DD/MM/YYYY")} dan ${moment(maxHari).format("DD/MM/YYYY")}`;

  const canProceedMobile =
    !!dataStep1?.unit && dateValid && !isSpecialBlocked && !belumBuka;

  const canProceedDesktop =
    !!dataStep1?.sbu &&
    !!dataStep1?.unit &&
    dateValid &&
    !!dataStep1?.rs &&
    !isSpecialBlocked &&
    !belumBuka &&
    !loadingPengumuman;

  // Bersihkan tanggal sisa (mis. dari localStorage/state lama) yang di luar rentang
  // saat halaman dibuka atau saat SBU/unit berubah. Tidak dijalankan saat mengetik.
  useEffect(() => {
    if (dataStep1?.date && !isDateInRange(dataStep1.date)) {
      setDataStep1({ ...dataStep1, date: "" });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataStep1?.sbu, dataStep1?.unit]);

  const handleHospitalSelect = (sbu) => {
    fetchSelectorUnit(sbu.value);
    const updatedDataStep1 = {
      ...dataStep1,
      sbu: sbu.value,
      sbuname: sbu.label,
      unit: null,
      unitname: null,
      date: "",
    };
    setDataStep1(updatedDataStep1);
    localStorage.setItem("dataStep1", JSON.stringify(updatedDataStep1));
    setShowUnitDateModal(true);
  };

  const handleUnitSelect = (e) => {
    setDataStep1({ ...dataStep1, unit: e.value, unitname: e.label, date: "" });
    setUnitJenis3(e.jenis3);
  };

  // onChange sengaja tidak mereset nilai: saat mengetik tahun, browser memicu
  // onChange di setiap digit (0002, 0020, 0202, 2026). Validasi dilakukan di
  // isInvalid + tombol + guard handler.
  const handleDateChange = (e) => {
    setDataStep1({ ...dataStep1, date: e.target.value || "" });
  };

  const handleDateSelect = () => {
    if (!canProceedMobile) return;
    setDataStep1({ ...dataStep1, visitDate: visitDate });
    setShowUnitDateModal(false);
    setShowRegistrationModal(true);
    setModalHistory(["registration"]);
  };

  const handleRegistrationModalClose = (registered) => {
    // Guard terakhir sebelum lanjut ke step berikutnya
    if (!dateValid || belumBuka || isSpecialBlocked) {
      setShowRegistrationModal(false);
      return;
    }
    setDataStep1({ ...dataStep1, rs: registered ? "Pernah" : "Belum" });
    setShowRegistrationModal(false);
    setModalHistory([]);
    handleNext();
  };

  const handleSelect = (sbu) => {
    setSelectedSBU(sbu);
    setShowModal(true);
  };

  return (
    <>
      {isMobile && (
        <Card.Title className="text-center">
          <strong>Pilih Unit & Tanggal Kunjungan</strong>
        </Card.Title>
      )}
      <br />

      {isMobile ? (
        /** === Mobile / Tablet Small View === */
        <>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Unit Rawat Jalan Tujuan</Form.Label>
              <Select
                styles={{ zIndex: 99999 }}
                id="unit"
                name="unit"
                options={selectorUnit.filter((unit) => unit.value !== "pilih_unit_tujuan")}
                isLoading={loadingUnit}
                value={selectorUnit.find((find) => find?.value === dataStep1?.unit)}
                onChange={handleUnitSelect}
              />
              {isSpecialTodayH1Unit && (
                <Form.Text style={{ color: "#b8860b", fontWeight: 600 }}>
                  ⏰ Pendaftaran online poli ini dibuka setiap hari mulai pukul 08:00 WIB.
                </Form.Text>
              )}
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Tanggal Kunjungan</Form.Label>
              <Form.Control
                type="date"
                id="tanggal"
                name="tanggal"
                value={dataStep1?.date || ""}
                onChange={handleDateChange}
                min={hariIni}
                max={maxHari}
                isInvalid={dateOutOfRange}
                disabled={!dataStep1?.unit || isSpecialBlocked}
              />
              <Form.Control.Feedback type="invalid">
                {dateErrorMessage}
              </Form.Control.Feedback>
            </Form.Group>
            <br />
            <div className="text-center">
              <Button
                onClick={handleDateSelect}
                disabled={!canProceedMobile}
                style={{
                  background: "linear-gradient(135deg, #56ab2f, #a8e063)",
                  border: "none",
                  color: "#fff",
                  width: "100%",
                }}
              >
                Lanjutkan
              </Button>
            </div>
          </Form>
        </>
      ) : (
        /** === Desktop / Tablet Large View === */
        <>
          <Card.Title>
            <Row>
              <Col lg={12} md={12} sm={12}>
                <strong>
                  (1/4) Pilih Unit Rawat Jalan dan Tanggal Kunjungan
                </strong>
              </Col>
            </Row>
          </Card.Title>
          <br />
          <Row>
            <Col className="d-none d-md-block" lg={5} md={5}>
              <Center>
                <img src="assets/img/medic-1.svg" width="100%" alt="gambar" />
              </Center>
            </Col>
            <Col lg={7} md={7} sm={12}>
              <Form>
                <Form.Group className="mb-3">
                  <Form.Label>Rumah Sakit Tujuan</Form.Label>
                  <Select
                    styles={{
                      color: "black",
                    }}
                    id="sbu"
                    name="sbu"
                    options={selectorSBU}
                    value={selectorSBU.find(
                      (find) => find?.value === dataStep1?.sbu
                    )}
                    onChange={(e) => {
                      fetchSelectorUnit(e.value);
                      setDataStep1({
                        ...dataStep1,
                        sbu: e.value,
                        sbuname: e.label,
                        unit: null,
                        unitname: null,
                        date: "",
                      });
                    }}
                    isDisabled={!!dataStep1?.sbu}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Unit Rawat Jalan Tujuan</Form.Label>
                  {dataStep1?.sbu ? (
                    <Select
                      styles={{
                        color: "black",
                        zIndex: 99999,
                      }}
                      id="unit"
                      name="unit"
                      options={selectorUnit}
                      isLoading={loadingUnit}
                      value={selectorUnit.find(
                        (find) => find?.value === dataStep1?.unit
                      )}
                      onChange={(e) => {
                        setDataStep1({
                          ...dataStep1,
                          unit: e.value,
                          unitname: e.label,
                          date: "",
                          rs: e.value === "P37" ? "Pernah" : null,
                        });
                        setUnitJenis3(e.jenis3);
                      }}
                    />
                  ) : (
                    <Form.Control
                      type="text"
                      value="Pilih Rumah Sakit Tujuan Terlebih Dahulu..."
                      disabled
                    />
                  )}
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Tanggal</Form.Label>
                  <Form.Control
                    type="date"
                    id="tanggal"
                    name="tanggal"
                    value={dataStep1?.date || ""}
                    onChange={handleDateChange}
                    min={hariIni}
                    max={maxHari}
                    isInvalid={dateOutOfRange}
                    disabled={!dataStep1?.unit || isSpecialBlocked}
                  />
                  <Form.Control.Feedback type="invalid">
                    {dateErrorMessage}
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Pernah Berobat ke RSPG Group (RSPG,RS Grha Husada, RSPG
                    Driyorejo)?
                  </Form.Label>
                  <Select
                    styles={{
                      color: "black",
                    }}
                    id="rs"
                    name="rs"
                    options={selectorRS}
                    isDisabled={dataStep1?.unit === "P37"}
                    value={selectorRS.find((find) => find?.value === dataStep1?.rs)}
                    onChange={(e) => {
                      setDataStep1({
                        ...dataStep1,
                        rs: e.value,
                      });
                    }}
                  />
                  {isSpecialTodayH1Unit && (
                    <Form.Text style={{ color: "#b8860b", fontWeight: 600 }}>
                      ⏰ Pendaftaran online poli ini dibuka setiap hari mulai pukul 08:00 WIB.
                    </Form.Text>
                  )}
                </Form.Group>
                <br />
                <Button
                  style={{ float: "right" }}
                  variant="primary"
                  disabled={!canProceedDesktop}
                  onClick={() => {
                    if (!canProceedDesktop) return; // pengaman tambahan
                    handleNext();
                  }}
                >
                  {loadingPengumuman ? "...Loading" : "Simpan & Lanjutkan"}
                  <Icons.ArrowRight size={18} />
                </Button>
              </Form>
            </Col>
          </Row>
        </>
      )}

      <Modal show={showRegistrationModal} onHide={() => setShowRegistrationModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Registrasi</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Apakah Anda sudah pernah mendaftar sebelumnya?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => handleRegistrationModalClose(false)}>
            Belum Pernah
          </Button>
          <Button variant="primary" onClick={() => handleRegistrationModalClose(true)}>
            Sudah Pernah
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}